<template>
    <div class="driver">
        <div class="text">
            <div class="mesg">
                <h2>Earn as a driver on Caby App today!</h2>
                <!-- <p>Herox helps businesses in Africa get paid by anyone, anywhere in the world securedly</p>  -->
            </div>
            <div class="butn">
                <form action=" https://getform.io/f/626e1ed4-fd0a-483e-a4a4-9b22dd191542" method="POST">
                    <input type="email" required placeholder="Enter your email address" name="email">
                    <input type="submit" value="Get Started">
                </form>
            </div>
        </div>
        <div class="image">
            <div class="img">
                <img src="../../assets/Rectangle33.png" alt="image">
            </div>
        </div>
        <div class="box">
            <div class="ellipse">
                <img src="../../assets/Ellipse111.png" alt="ellipse" class="img1">
                <img src="../../assets/Ellipse111.png" alt="ellipse" class="img2">
                <img src="../../assets/Ellipse111.png" alt="ellipse" class="img3">
                <img src="../../assets/Ellipse111.png" alt="ellipse" class="img4">
                <img src="../../assets/Ellipse111.png" alt="ellipse" class="img5">
            </div>
           <ApplyToDrive />
        </div>
    </div>
</template>
<script>
import ApplyToDrive from '../ApplyToDrive.vue';

    export default {
    components: { ApplyToDrive }
}
</script>
<style scoped>
    .driver{
        position: relative;
        width: 100%;
        margin: 0;
        margin-bottom: 3rem;
    }
    .driver .text{
        position: relative;
        padding: 0;
        text-align: center;
    }
    .text .mesg{
        padding: 0 1rem;
        margin-bottom: 3rem;
    }
    .text h2{
        position: relative;
        color: #1b2124;
        line-height: 32px;
        font-weight: bold;
        font-size: 24px;
        margin-bottom: 15px;
        font-family: 'Inter', sans-serif;
    }
    .text p{
        color: #475467;
        line-height: 22px;
        margin-bottom: 1rem;
        font-family: 'Inter', sans-serif;
    }
    .text .butn{
        position: relative;
        width: 100%;
        padding: 0 1rem;
    }
    .text .butn form{
        width: 100%;
        gap: 10px;
        display: flex;
    }
    .butn input{
        border: none;
        outline: none;
        padding: 11px;
        border-radius: 8px;
        font-size: 11px;
        width: 100%;
    }
    .butn input[type="email"]{
        background-color: #F6CF94;
        color: #475467;
        font-family: 'Inter', sans-serif;
    }
    .butn input[type="submit"]{
        background-color: #f60;
        color: #fff;
        width: 30%;
        font-family: 'Inter', sans-serif;
    }
    .driver .image{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
        padding: 1rem;
        margin-bottom: 1rem;
    }
    .image .img{
        position: relative;
        width: 100%;
        height: 300px;
    }
    .image .img img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%; 
        height: 100%;
    }
    .driver .box{
        position: relative;
        width: 100%;
        padding: 0 1rem;
        margin: 0;
    }
    /* Setting the ellipses to display none on mobile and tablet view */
    .box .ellipse{
        display: none;
    }

    @media screen and (min-width:768px) {
        .driver{
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-auto-rows: auto auto;
            gap: 1rem;
        }
        .driver .text{
            padding-left: 3rem;
            text-align: left;
            align-self: center;
        }
        .text .mesg, .text .butn{
            padding: 0;
        }
        .text h2{
            line-height: 52px;
            font-weight: 600;
            font-size: 44px;
            margin-bottom: 15px;
        }
        .text p{
            font-size: 17px;
            line-height: 22px;
            margin-bottom: 1rem;
        }
        .butn input{
            padding: 12.5px;
            font-size: 12px;
        }
        .driver .image{
            padding-right: 3rem;
        }
        .image .img {
            height: 400px;
        }
        .driver .box{
            grid-column: 1/3;
            grid-row: 2;
        }
    }
    @media screen and (min-width:1010px) {
        .driver{
            column-gap: 2rem;
        }
        .text h2{
            line-height: 62px;
            font-weight: 600;
            font-size: 60px;
            margin-bottom: 15px;
        }
        .text p{
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 1rem;
        }
        .butn input{
            padding: 14.5px;
            font-size: 14px;
        }
        .driver .text{
            padding-left: 4.5rem;
            padding-top: 3rem;
            align-self: flex-start;
        }
        .driver .image{
            padding-right: 4.5rem;
            margin-bottom: 3.5rem;
        }
        .image .img{
            height: 500px;
        }
        .box .ellipse{
            display: unset;
            position: absolute;
            height: 420px;
            height: 329px;
        }
        .box .ellipse img{
            position: absolute;
            left: 20px;
            width: 270px;
        }
        .box .ellipse .img1{
            top: -160px;
            left: 20px;
        }
        .box .ellipse .img2{
            top: -160px;
            left: 40px;
        }
        .box .ellipse .img3{
            top: -150px;
            left: 80px;
        }
        .box .ellipse .img4{
            top: -150px;
            left: 90px;
        }
        .box .ellipse .img5{
            top: -150px;
            left: 100px;
        }
    }
    @media screen and (min-width: 1280px) {
        .driver{
            column-gap: 4rem;
        }
        .text h2{
            line-height: 83px;
            font-weight: 600;
            font-size: 72px;
        }
        .text p{
            font-size: 20px;
            line-height: 37px;
        }
        .image{
            width: 100%;
            position: relative;
            height: 612px;
        }
        .image .img{
            position: absolute;
            top: 0;
            right: 4.5rem;
            width: 521px;
            height: 612px;
        }
        .box .ellipse img{
            position: absolute;
            left: 20px;
            width: 300px;
        }
        .box .ellipse .img1{
            top: -210px;
            left: 20px;
        }
        .box .ellipse .img2{
            top: -210px;
            left: 40px;
        }
        .box .ellipse .img3{
            top: -190px;
            left: 80px;
        }
        .box .ellipse .img4{
            top: -190px;
            left: 90px;
        }
        .box .ellipse .img5{
            top: -190px;
            left: 100px;
        }
    }
</style>